import { AdminPanelSettings, VFlex, VTextButton } from '@/package';

const DelegationBar = () => {
  return (
    <VFlex
      className="bg-gradient-to-r from-[#FFAC2F] from-[46.15%] to-[#9FE0F0] px-8 py-2 text-body-xl font-semibold text-blue-300"
      items="center"
      justify="between"
    >
      <VFlex gap={0.5} items="center">
        <AdminPanelSettings className="size-5" />
        <div>
          You’re viewing this tenant in read-only mode with an admin token —
          changes are not allowed
        </div>
      </VFlex>

      <VTextButton size="sm">
        <a
          target="_blank"
          href={`${import.meta.env.DEV ? import.meta.env.VITE_APP_DEV_ADMIN_URL : import.meta.env.VITE_APP_ADMIN_URL}`}
        >
          Return to VueX admin
        </a>
      </VTextButton>
    </VFlex>
  );
};

DelegationBar.displayName = 'DelegationBar';

export default DelegationBar;
